<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition" :persistent="true">
        <div id="app" class="my-0 py-0">
            <div ref="printableSection" id="pdfimprimir">
                <v-app id="inspire">
                    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                        <v-card class="py-0">
                            <v-toolbar class="py-0 my-0" dark color="blue">
                                <v-toolbar-title class="my-0 py-0">ESTUDIO DE FACTIBILIDAD
                                    (Determinación de la factibilidad y conveniencia) (EI 018)
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                Factibilidad: {{ fact }}
                                <v-spacer></v-spacer>
                                <v-btn class="mx-2" fab dark small color="primary" onclick=print()>
                                    <v-icon dark>
                                        mdi-printer
                                    </v-icon>
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn icon dark @click="show = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </v-toolbar>
                        </v-card>
                        <v-card color="blue lighten-4">
                            <v-card-text>
                                <v-row dense>
                                    <v-col cols="6" sm="4" md="2">
                                        <v-text-field required :rules="requiredRules" label="Fecha" dense
                                            v-model="fecha"></v-text-field>
                                    </v-col>
                                    <v-col cols="6" sm="6" md="4">
                                        <v-text-field label="Cliente:" dense v-model="cliente">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="6" sm="6" md="4">
                                        <v-text-field label="Obra:" dense v-model="obra">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="6" sm="4" md="2">
                                        <v-text-field required :rules="requiredRules" label="Fecha Presentación" dense
                                            v-model="fechapres"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                        <v-card color="blue lighten-5" class="py-0 my-0">
                            <v-card-text class="py-0 my-0">
                                <v-row dense>
                                    <FONT SIZE=2 color="black"><b>1. CONVENIENCIA ESTRATÉGICA RESPECTO DEL PROYECTO:
                                        </b></FONT>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-radio-group v-model="convestr" row dense>
                                            <v-radio label="100% - MUY BUENO" value="M"></v-radio>
                                            <v-radio label="75% - BUENO" value="B"></v-radio>
                                            <v-radio label="50% - REGULAR" value="R"></v-radio>
                                            <v-radio label="25% - INACEPTABLE" value="I"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                        <v-card color="white" class="py-0 my-0">
                            <v-card-text class="py-0 my-0">
                                <v-row dense>
                                    <FONT SIZE=2 color="black"><b>2. FACTIBILIDAD ECONÓMICO-FINANCIERA: </b></FONT>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-radio-group v-model="factecon" row dense>
                                            <v-radio label="100% - MUY BUENO" value="M"></v-radio>
                                            <v-radio label="75% - BUENO" value="B"></v-radio>
                                            <v-radio label="50% - REGULAR" value="R"></v-radio>
                                            <v-radio label="25% - INACEPTABLE" value="I"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                        <v-card color="blue lighten-5" class="py-0 my-0">
                            <v-card-text class="py-0 my-0">
                                <v-row dense>
                                    <FONT SIZE=2 color="black"><b>3. CONCEPTOS SOBRE EL CLIENTE: </b></FONT>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-radio-group v-model="concepto" row dense>
                                            <v-radio label="100% - MUY BUENO" value="M"></v-radio>
                                            <v-radio label="75% - BUENO" value="B"></v-radio>
                                            <v-radio label="50% - REGULAR" value="R"></v-radio>
                                            <v-radio label="25% - INACEPTABLE" value="I"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                        <v-card color="white" class="py-0 my-0">
                            <v-card-text class="py-0 my-0">
                                <v-row dense>
                                    <FONT SIZE=2 color="black"><b>4. FACTIBILIDAD TÉCNICA: </b></FONT>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-radio-group v-model="facttec" row dense>
                                            <v-radio label="100% - MUY BUENO" value="M"></v-radio>
                                            <v-radio label="75% - BUENO" value="B"></v-radio>
                                            <v-radio label="50% - REGULAR" value="R"></v-radio>
                                            <v-radio label="25% - INACEPTABLE" value="I"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                        <v-card color="blue lighten-5" class="py-0 my-0">
                            <v-card-text class="py-0 my-0">
                                <v-row dense>
                                    <FONT SIZE=2 color="black"><b>5. CAPACIDAD PARA DAR RESPUESTA A REQUERIMIENTOS DEL
                                            CLIENTE EN
                                            MATERIA
                                            DE INEGENIERÍA /
                                            PRODUCCIÓN / ADMINISTRACIÓN / TECNOLOGÍA: </b></FONT>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-radio-group v-model="capacidad" row dense>
                                            <v-radio label="100% - MUY BUENO" value="M"></v-radio>
                                            <v-radio label="75% - BUENO" value="B"></v-radio>
                                            <v-radio label="50% - REGULAR" value="R"></v-radio>
                                            <v-radio label="25% - INACEPTABLE" value="I"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                        <v-card color="white" class="py-0 my-0">
                            <v-card-text class="py-0 my-0">
                                <v-row dense>
                                    <FONT SIZE=2 color="black"><b>6. CAPACIDAD PARA DAR RESPUESTA A REQUERIMIENTOS DEL
                                            CLIENTE EN
                                            MATERIA
                                            DE CALIDAD,
                                            MEDIO AMBIENTE Y SST:</b> </FONT>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-radio-group v-model="capacidadsgi" row dense>
                                            <v-radio label="100% - MUY BUENO" value="M"></v-radio>
                                            <v-radio label="75% - BUENO" value="B"></v-radio>
                                            <v-radio label="50% - REGULAR" value="R"></v-radio>
                                            <v-radio label="25% - INACEPTABLE" value="I"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                        <v-card color="blue lighten-5" class="py-0 my-0">
                            <v-card-text class="py-0 my-0">
                                <v-row dense class="py-0 my-0">
                                    <FONT SIZE=2 color="black"><b>RESUMEN: </b></FONT>
                                </v-row>
                                <v-row dense class="py-0 my-0">
                                    <v-col cols="12" sm="12" md="12">
                                        <v-radio-group v-model="resumen" row dense>
                                            <v-radio label="100% - MUY BUENO" value="M"></v-radio>
                                            <v-radio label="75% - BUENO" value="B"></v-radio>
                                            <v-radio label="50% - REGULAR" value="R"></v-radio>
                                            <v-radio label="25% - INACEPTABLE" value="I"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                        <v-card color="blue lighten-4" class="py-0 my-0">
                            <v-card-text class="py-0 my-0">
                                <v-row dense>
                                    <v-col cols="10" sm="6" md="6">
                                        <FONT SIZE=2 color="black"><b>COTIZA? </b></FONT>
                                        <v-radio-group v-model="cotiza" row dense>
                                            <v-radio label="SI" value="S"></v-radio>
                                            <v-radio label="NO" value="N"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="10" sm="6" md="6">
                                        <v-textarea label="Observaciones" auto-grow rows="2" outlined
                                            v-model="observ"></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                        <v-card color="blue" dark tile>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn v-if="this.estado != 'C'" color="success" @click.stop="guardar"
                                    :disabled="deshabilitar">Guardar</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-app>
            </div>
        </div>
    </v-dialog>
</template>

<style lang="scss">
.v-input--radio-group__input {
    label {
        margin: 0 !important;
    }
}
</style>
<style>
@media print {

    html,
    body {
        height: 100%;
        margin: 0 !important;
        padding: 0 !important;
        overflow: hidden;
        @page: second: hidden;
    }

    .print:last-child {
        page-break-after: auto;
    }
}
</style>
<!-- <style scoped>
.printable-content {
  width: 100%;
}

/* Clase CSS para reducir el tamaño de la letra */
.font-small {
  font-size: 10% !important; /* Aplica un tamaño de fuente reducido */
}
</style>  -->

<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";

export default {
    data: (vm) => ({
        usuario: "",
        valid: false,
        deshabilitar: false,
        lazy: false,
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        cliente: "",
        obra: "",
        fecha: moment().format("DD/MM/YYYY"),
        fechapres: "",
        convestr: "",
        factecon: "",
        concepto: "",
        facttec: "",
        capacidad: "",
        capacidadsgi: "",
        resumen: "",
        cotiza: "",
        observ: "",
        estado: "",
        mensaje: "",
    }),
    props: ["visible", "fact"],

    computed: {
        show: {
            get() {
                if (this.fact != "" && this.fact != null && this.visible == true) {
                    console.log("FACT: " + this.fact)
                    this.cargarFactibilidad();
                }
                return this.visible;
                // this.codigopedido();
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },
    methods: {

        vaciarModels() {
            this.cliente = "";
            this.obra = "";
            this.convestr = "";
            this.factecon = "";
            this.concepto = "";
            this.facttec = "";
            this.capacidad = "";
            this.capacidadsgi = "";
            this.resumen = "";
            this.cotiza = "";
            this.observ = "";
            this.fecha = moment().format("DD/MM/YYYY");
            this.fechapres = "";
            this.deshabilitar = false;
        },

        cargarFactibilidad() {
            const fact = this.fact;
            let self = this;
            axios
                .get("/Comercial/CargarFactibilidad?", {
                    params: {
                        fact: fact,
                    },
                })
                .then((response) => {
                    self.cliente = response.data.empresa;
                    self.obra = response.data.descr;
                    self.fechapres = response.data.fechapres;
                    self.convestr = response.data.convestr;
                    self.factecon = response.data.factecon;
                    self.facttec = response.data.facttec;
                    self.capacidad = response.data.capacidad;
                    self.capacidadsgi = response.data.capacidadsgi;
                    self.concepto = response.data.concepto;
                    self.resumen = response.data.resumen;
                    self.observ = response.data.observ;
                    self.cotiza = response.data.cotiza;
                    self.estado = response.data.estado;
                })
                .catch((error) => {
                    self.cliente = "";
                    self.obra = "";
                    console.log(error);
                });
        },

        guardar() {
            this.$swal({
                title: "Guardar Factibilidad",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.deshabilitar = true;
                    var datos = {
                        fact: this.fact,
                        empresa: this.cliente,
                        obra: this.obra,
                        fecha: this.fecha,
                        fechapres: this.fechapres,
                        convestr: this.convestr,
                        factecon: this.factecon,
                        concepto: this.concepto,
                        facttec: this.facttec,
                        capacidad: this.capacidad,
                        capacidadsgi: this.capacidadsgi,
                        resumen: this.resumen,
                        cotiza: this.cotiza,
                        observ: this.observ,
                    };
                    let self = this;
                    axios
                        .post("/Comercial/GuardarFactibilidad", datos)
                        .then((response) => {
                            self.mensaje = response.data;
                            self.$refs.form.resetValidation();

                            self.showAlert({
                                icon: "success",
                                title: self.mensaje,
                                vm: self,
                            });
                            self.vaciarModels();
                            self.$emit("close");
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            });
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 8000,
            });
        },
    },
};
</script>
